<template>
  <div class="reg">
    <div class="row">
      <div class="col-lg-5 mb-1">
        <b-card
          no-body
          class="reg__coluna"
        >
          <div class="reg__busca">
            <div class="reg__campo">
              <feather-icon
                icon="SearchIcon"
                size="15"
                class="reg__lupa"
              />
              <input
                v-model="busca"
                type="text"
                class="form-control form-control-sm"
                :placeholder="$t('retention.occurrences.searchPlaceholder')"
                @keyup.enter="buscar"
              >
            </div>
            <button
              class="btn btn-sm btn-outline-secondary"
              :disabled="carregando"
              :title="busca ? $t('retention.occurrences.clearSearch') : $t('retention.index.refresh')"
              @click="busca ? limpar() : carregar()"
            >
              <feather-icon
                :icon="busca ? 'XIcon' : 'RefreshCwIcon'"
                size="14"
              />
            </button>
          </div>

          <div class="reg__abas">
            <button
              v-for="f in filtros"
              :key="f.valor"
              type="button"
              class="reg__aba"
              :class="{ 'reg__aba--ativa': filtro === f.valor }"
              @click="mudarFiltro(f.valor)"
            >
              {{ f.rotulo }}
            </button>
          </div>

          <div class="reg__resumo">
            <span><strong>{{ resumo.total }}</strong> {{ $t('retention.occurrences.occurrencesSuffix') }}</span>
            <span class="reg__ponto" />
            <span><strong>{{ resumo.com_equipamento }}</strong> {{ $t('retention.occurrences.withEquipmentSuffix') }}</span>
            <template v-if="resumo.com_retencao">
              <span class="reg__ponto" />
              <span class="text-warning">
                <strong>{{ resumo.com_retencao }}</strong> {{ $t('retention.occurrences.withRetentionSuffix') }}
              </span>
            </template>
          </div>

          <div
            v-if="carregando"
            class="text-center py-4"
          >
            <b-spinner
              small
              variant="primary"
            />
          </div>

          <div
            v-else-if="candidatas.length === 0"
            class="reg__vazio"
          >
            <feather-icon
              icon="PackageIcon"
              size="26"
            />
            <p class="mb-0 mt-1">
              {{ busca ? $t('retention.occurrences.emptySearch') : $t('retention.occurrences.emptyNode') }}
            </p>
          </div>

          <div
            v-else
            class="reg__lista"
          >
            <button
              v-for="o in candidatas"
              :key="o.id"
              type="button"
              class="reg__item"
              :class="{ 'reg__item--ativo': selecionada && selecionada.id === o.id }"
              @click="selecionar(o)"
            >
              <div class="reg__item-topo">
                <span class="reg__proto">{{ o.protocol }}</span>
                <span :class="Number(o.status) === 2 ? 'selo selo--fechada' : 'selo selo--aberta'">
                  {{ Number(o.status) === 2 ? $t('retention.occurrences.statusClosed') : $t('retention.occurrences.statusOpen') }}
                </span>
              </div>
              <div class="reg__quem">
                {{ o.requester_name || $t('retention.occurrences.noRequester') }}
              </div>
              <div class="reg__onde">
                {{ endereco(o) }}
              </div>
              <div class="reg__chips">
                <span class="reg__chip">{{ o.em_campo }} {{ $t('retention.occurrences.inFieldSuffix') }}</span>
                <span
                  v-if="o.retido"
                  class="reg__chip reg__chip--retido"
                >{{ o.retido }} {{ $t('retention.occurrences.retainedSuffix') }}</span>
                <span class="reg__quando">{{ curto(o.created_at) }}</span>
              </div>
            </button>
          </div>

          <div
            v-if="paginacao.last_page > 1"
            class="reg__paginacao"
          >
            <pagination
          :options="opcoesPaginacao"
              v-model="paginacao.current_page"
              :records="paginacao.total"
              :per-page="paginacao.per_page"
              @paginate="carregar"
            />
          </div>
        </b-card>
      </div>

      <div class="col-lg-7">
        <b-card
          v-if="!selecionada"
          class="reg__placeholder"
        >
          <feather-icon
            icon="ArrowLeftCircleIcon"
            size="30"
          />
          <h6 class="mt-1 mb-25">
            {{ $t('retention.occurrences.selectOccurrenceTitle') }}
          </h6>
          <p class="text-muted mb-0">
            {{ $t('retention.occurrences.selectOccurrenceHint') }}
          </p>
        </b-card>

        <b-card
          v-else
          no-body
          class="reg__detalhe"
        >
          <div class="reg__detalhe-topo">
            <div>
              <span class="reg__proto reg__proto--grande">{{ selecionada.protocol }}</span>
              <div class="reg__quem mt-25">
                {{ selecionada.requester_name || $t('retention.occurrences.noRequester') }}
              </div>
              <div class="reg__onde">
                {{ endereco(selecionada) }}
              </div>
            </div>
            <button
              class="btn btn-sm btn-outline-secondary"
              :title="$t('retention.occurrences.close')"
              @click="selecionada = null"
            >
              <feather-icon
                icon="XIcon"
                size="14"
              />
            </button>
          </div>

          <div class="p-1">
            <OccurrenceEquipmentPanel
              :occurrence-id="selecionada.id"
              standalone
              @carregado="aoCarregarPainel"
            />
          </div>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from 'vue-pagination-2'
import opcoesPaginacao from '@/libs/paginationOptions'
import ApiErrorMixin from '@/mixins/ApiErrorMixin'
import OccurrenceEquipmentPanel from '@/components/OccurrenceEquipmentPanel.vue'

export default {
  name: 'RetentionOccurrences',
  components: { OccurrenceEquipmentPanel, Pagination },
  mixins: [ApiErrorMixin],

  data() {
    return {
      candidatas: [],
      resumo: { total: 0, com_equipamento: 0, com_retencao: 0 },
      paginacao: {
        current_page: 1, per_page: 20, last_page: 1, total: 0,
      },
      selecionada: null,
      busca: '',
      filtro: '',
      filtros: [
        { valor: '', rotulo: this.$t('retention.occurrences.filterAll') },
        { valor: 'com_equipamento', rotulo: this.$t('retention.occurrences.filterWithEquipment') },
        { valor: 'com_retencao', rotulo: this.$t('retention.occurrences.filterWithRetention') },
      ],
      carregando: false,
    }
  },

  mounted() {
    this.carregar()
  },

  computed: {
    opcoesPaginacao() {
      return opcoesPaginacao
    },
  },

  methods: {
    buscar() {
      this.paginacao.current_page = 1
      this.carregar()
    },

    async carregar() {
      this.carregando = true
      try {
        const params = {
          page: this.paginacao.current_page,
          per_page: this.paginacao.per_page,
        }
        if (this.busca) params.search = this.busca
        if (this.filtro) params.filtro = this.filtro

        const res = await this.$http.get(`${this.$store.state.api}equipment/retentions/candidates`, { params })
        const pg = res.data.data || {}
        this.candidatas = pg.data || []
        this.paginacao.total = pg.total || 0
        this.paginacao.last_page = pg.last_page || 1
        this.paginacao.current_page = pg.current_page || 1
        this.resumo = res.data.summary || this.resumo

        if (this.selecionada && !this.candidatas.some(o => o.id === this.selecionada.id)) {
          this.selecionada = null
        }
      } catch (e) {
        this.candidatas = []
        this.$message(this.$t('retention.common.errorTitle'), this.apiErrorText(e, this.$t('retention.occurrences.loadError')), 'error')
      } finally {
        this.carregando = false
      }
    },

    limpar() {
      this.busca = ''
      this.paginacao.current_page = 1
      this.carregar()
    },

    mudarFiltro(valor) {
      if (this.filtro === valor) return

      this.filtro = valor
      this.paginacao.current_page = 1
      this.carregar()
    },

    selecionar(o) {
      this.selecionada = this.selecionada && this.selecionada.id === o.id ? null : o
    },

    aoCarregarPainel() {
      this.carregar()
    },

    endereco(o) {
      if (!o.address) return this.$t('retention.occurrences.noAddress')
      const numero = o.number ? `, ${o.number}` : ''
      const bairro = o.neighborhood ? ` — ${o.neighborhood}` : ''

      return `${o.address}${numero}${bairro}`
    },

    curto(iso) {
      if (!iso) return '—'
      return new Date(iso).toLocaleString('pt-BR', {
        day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit',
      })
    },
  },
}
</script>

<style scoped>
.reg__coluna {
  overflow: hidden;
}

.reg__busca {
  display: flex;
  gap: 8px;
  padding: 12px 14px 8px;
}

.reg__campo {
  position: relative;
  flex: 1 1 auto;
}

.reg__campo input {
  padding-left: 30px;
}

.reg__lupa {
  position: absolute;
  left: 9px;
  top: 50%;
  transform: translateY(-50%);
  color: #b9b9c3;
  pointer-events: none;
}

.reg__resumo {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 14px 10px;
  font-size: 11.5px;
  color: #8592a3;
  border-bottom: 1px solid #ebe9f1;
}

.reg__ponto {
  width: 3px;
  height: 3px;
  border-radius: 50%;
  background: #d8d6de;
}

.reg__abas {
  display: flex;
  gap: 4px;
  padding: 0 14px 8px;
}

.reg__aba {
  border: none;
  background: none;
  padding: 3px 9px;
  border-radius: 12px;
  font-size: 11.5px;
  font-weight: 600;
  color: #8592a3;
  cursor: pointer;
}

.reg__aba--ativa {
  background: rgba(115, 103, 240, 0.12);
  color: #7367f0;
}

.dark-layout .reg__aba--ativa {
  background: rgba(115, 103, 240, 0.22);
  color: #a99cff;
}

.reg__paginacao {
  display: flex;
  justify-content: center;
  padding: 10px 14px 2px;
  border-top: 1px solid #ebe9f1;
}

.dark-layout .reg__paginacao {
  border-top-color: #3b4253;
}

.reg__vazio {
  padding: 34px 16px;
  text-align: center;
  color: #b9b9c3;
  font-size: 13px;
}

.reg__lista {
  max-height: 66vh;
  overflow-y: auto;
}

.reg__item {
  display: block;
  width: 100%;
  text-align: left;
  padding: 10px 14px;
  border: none;
  border-left: 3px solid transparent;
  border-bottom: 1px solid #f3f2f7;
  background: none;
  cursor: pointer;
}

.reg__item:hover {
  background: #f8f8fb;
}

.reg__item--ativo {
  border-left-color: #7367f0;
  background: rgba(115, 103, 240, 0.07);
}

.reg__item-topo {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.reg__proto {
  font-family: monospace;
  font-weight: 600;
  font-size: 13px;
  color: #7367f0;
}

.reg__proto--grande {
  font-size: 15px;
}

.reg__quem {
  font-size: 12.5px;
  font-weight: 600;
  color: #5e5873;
  margin-top: 3px;
}

.reg__onde {
  font-size: 11.5px;
  color: #8592a3;
  margin-top: 1px;
}

.reg__chips {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 6px;
}

.reg__chip {
  font-size: 10.5px;
  font-weight: 600;
  padding: 2px 7px;
  border-radius: 10px;
  background: #f3f2f7;
  color: #6e6b7b;
}

.reg__chip--retido {
  background: rgba(255, 159, 67, 0.16);
  color: #b45309;
}

.reg__quando {
  margin-left: auto;
  font-size: 10.5px;
  color: #b9b9c3;
}

.reg__placeholder {
  text-align: center;
  color: #b9b9c3;
  padding: 36px 20px;
}

.reg__detalhe-topo {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
  padding: 14px;
  border-bottom: 1px solid #ebe9f1;
}

.selo {
  display: inline-block;
  font-size: 0.7rem;
  font-weight: 600;
  padding: 2px 7px;
  border-radius: 4px;
  white-space: nowrap;
}

.selo--aberta {
  color: #28c76f;
  background: rgba(40, 199, 111, 0.12);
}

.selo--fechada {
  color: #8592a3;
  background: rgba(133, 146, 163, 0.14);
}

/* dark mode */
.dark-layout .reg__resumo,
.dark-layout .reg__detalhe-topo {
  border-bottom-color: #3b4253;
}

.dark-layout .reg__item {
  border-bottom-color: #3b4253;
}

.dark-layout .reg__item:hover {
  background: #232a3d;
}

.dark-layout .reg__item--ativo {
  background: rgba(115, 103, 240, 0.16);
}

.dark-layout .reg__quem {
  color: #d0d2d6;
}

.dark-layout .reg__chip {
  background: #343d55;
  color: #b4b7bd;
}

.dark-layout .reg__chip--retido {
  background: rgba(255, 159, 67, 0.2);
  color: #e5a95c;
}

.dark-layout .reg__ponto {
  background: #4b5468;
}
</style>
